module.exports = __webpack_public_path__ + "assets/static/png/hand-coin.2a47c84a3a4c970fc64be56e133c95a3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/serviceReceipt/images/hand-coin.png
 ** module id = 529
 ** module chunks = 1
 **/